module.exports = __webpack_public_path__ + "img/1723086007187-WhatsApp Image 2024-08-07 at 16.38.11.jpeg.4994bce1.webp";